import { render, staticRenderFns } from "./ModalSeries.vue?vue&type=template&id=5b40de79&"
import script from "./ModalSeries.vue?vue&type=script&lang=ts&"
export * from "./ModalSeries.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSeries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports